import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Privacy Policy - Wisdom Consultancy</title>
      </Helmet>

      <section className="bg-gray-50 py-20 min-h-screen">
        <div className="container-custom max-w-4xl bg-white rounded-3xl shadow-xl p-8 md:p-14 border border-gray-100">
          <h1 className="text-4xl md:text-5xl font-extrabold text-[#0b1c39] mb-8 border-b pb-6">
            Privacy Policy
          </h1>

          <div className="prose prose-lg text-gray-600 max-w-none space-y-8">
            <div>
              <h2 className="text-2xl font-bold text-[#2e56b8] mb-4">1. What User Data Collected</h2>
              <p>
                We collect personal information that you voluntarily provide to us when you express an interest in obtaining information about us or our products and services, when you participate in activities on the Website or otherwise when you contact us. This may include your name, email address, phone number, location, and any other information you choose to provide.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-[#2e56b8] mb-4">2. Mobile / Email Collection</h2>
              <p>
                When you use our services or calculators, we may ask you to provide your email address and mobile number. By providing these details, you consent to receive communication from us regarding your queries, financial products, and promotional offers.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-[#2e56b8] mb-4">3. Cookies</h2>
              <p>
                We use cookies and similar tracking technologies to access or store information. Cookies help us understand how you use our site and improve your experience. You can choose to accept or decline cookies through your browser settings.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-[#2e56b8] mb-4">4. WhatsApp Communication</h2>
              <p>
                By providing your mobile number, you expressly consent to receive communications from us via WhatsApp. We may use WhatsApp to send you important updates, reports, and follow-ups related to your consultation or calculator results.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-[#2e56b8] mb-4">5. Data Sharing Policy</h2>
              <p>
                We do not sell or rent your personal information to third parties. We may share your data with trusted partners and service providers who assist us in operating our website and conducting our business, provided those parties agree to keep this information confidential.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-[#2e56b8] mb-4">6. Third-Party Tools</h2>
              <p>
                Our website may use third-party tools, APIs, and analytics services (such as Google Analytics). These third parties may collect information about your online activities over time and across different websites.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-[#2e56b8] mb-4">7. User Consent</h2>
              <p>
                By using our website, submitting your information, or using our calculators, you hereby consent to our Privacy Policy and agree to its terms.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-[#2e56b8] mb-4">8. Data Security</h2>
              <p>
                We implement appropriate technical and organizational security measures designed to protect the security of any personal information we process. However, please also remember that we cannot guarantee that the internet itself is 100% secure.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-[#2e56b8] mb-4">9. Policy Updates</h2>
              <p>
                We may update this privacy policy from time to time. The updated version will be indicated by an updated "Revised" date and the updated version will be effective as soon as it is accessible. We encourage you to review this privacy policy frequently to be informed of how we are protecting your information.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PrivacyPolicy;
